import styled from '@emotion/styled/macro';
import { colors, sizes } from '../../../../../../common/styles/theme.styles';
import { flexCenter } from '../../../../../../common/styles/combos.styles';



export const CenterContent = styled.div`
    width: 100%;
    // max-width: 816px;
    max-width: ${sizes.wealthContentWidth + 32}px;
    margin: 0 auto;
    min-height:100%;
`;

export const AssetVipSyncingTabWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:16px 0 24px;
`;

export const NewVipSyncBadge = styled.div`
    ${flexCenter};
    padding: 3px 7px;
    width: fit-content;
    border-radius: 36px;
    background: #DEB482;
    color: #fff;
    font-family: Circular;
    font-size: 12px;
    font-weight: 500;
`;

export const ItemLogoWrapper = styled.div`
    height:48px;
    width:48px;
    border-radius: 50%;
    position:relative;
    /* margin-right:12px; */
    img{
        height:48px;
        width:48px;
    }
`;

export const LogoPlaceHolder = styled.div`
    ${flexCenter}
    height:48px;
    width:48px;
    min-width:48px;
    background-color:${colors.gray3};
    border-radius:50%;
    svg{
        height:32px;
        width:32px;
    }
`;

export const VipBadgeWrapper = styled.div`
    ${flexCenter};
    position:absolute;
    top:-5px;
    right:-5px;
    
`;

export const PromptWrapper = styled.div`
    color: ${colors.darkGray1};
    text-align: center;
    font-family: Domine;
    font-size: 18px;
    font-weight: 400;
    white-space: pre-line;
    padding-top: 8px;
`;

export const ConsentReminder = styled.div`
    color: #DEB482;
    text-align: center;
    font-family: Circular;
    font-size: 14px;
    font-weight: 450;
    white-space: pre-line;
    padding-top: 6px;
`;

export const CloseButtonWrapper = styled.div`
    display: inline-flex;
    align-self: flex-end;
    padding: 10px 0 10px;
    cursor: pointer;
`;

// New Styles for VIP Sync Status Card

export const SyncStatusCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    
    max-width: 320px;
    ${props=> props.showAsCard ? `
        border-radius: 20px;
        background-color: white;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
        border:1px solid ${colors.gray3};    
        margin-top: 16px;
        padding: 24px;
    ` : ``}
    
    
`;

export const StatusStep = styled.div`
    display: flex;
    align-items: flex-start;
    padding: 12px 0;
    position: relative;

    &:not(:last-child):after {
        content: "";
        position: absolute;
        top: 16px;
        left: 12px;
        height: 100%;
        width: ${props=> props.lineColor ? '2' : '1'}px;
        background-color: ${props=> props.lineColor || colors.gray3};
    }
`;

export const StepIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-right: 16px;
    flex-shrink: 0;
    z-index: 1;
`;

export const StepIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    z-index: 1;
    background-color: ${props => props.completed ? '#DEB482' : props.active ? 'white' : colors.gray3};
    border: ${props => props.active ? '1px solid #DEB482' : 'none'};
    color: ${props => props.completed ? 'white' : props.active ? '#DEB482' : 'white'};
`;

export const StepContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StepTitle = styled.div`
    font-family: Circular;
    font-size: ${props => props.isAfterCreationModal ? '16px' : '14px'};
    font-weight: 700;
    color: ${props => props.isToolTip ? '#fff' : colors.darkGray2};
    margin-bottom: 4px;
`;

export const StepDescription = styled.div`
    font-family: Circular;
    font-size: ${props => props.isAfterCreationModal ? '13px' : '12px'};
    font-weight: 450;
    color: ${props => props.isToolTip ? colors.gray2 : colors.darkGray2};
    
`;

export const EntityName = styled.span`
    font-weight: 500;
    font-style: italic;
`;

export const EmptyCircleStep = styled.div`
    width: 16px;
        height: 16px;
    border-radius: 23px;
border: 1px solid ${colors.gray3};
background: ${props => props.bgColor ? props.bgColor : '#FFF'};

/* Toggle Shadow */
box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.16);
`;
